import { render, staticRenderFns } from "./ArticleContent.vue?vue&type=template&id=25a9d84a&scoped=true"
import script from "./ArticleContent.vue?vue&type=script&lang=js"
export * from "./ArticleContent.vue?vue&type=script&lang=js"
import style0 from "./ArticleContent.vue?vue&type=style&index=0&id=25a9d84a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25a9d84a",
  null
  
)

export default component.exports